import Vue from 'vue'
import Vuex from 'vuex'
import api from '../api/apis'
import router from '../router'
import { public_data } from '../libs/public_data'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    loadOver: false,
    hrefName: '',
    isArticel: {
      type: 'info',
      status: true,
      params: {}
    },
    // 中部导航
    meanCenterObj: {
      title: "首页",
      name: 'Index',
      id: 0,
      _child: []
    },
    system: '',
    // 头部导航
    meanTree: '',
    menus: '',
    company: '',
    pageCate: '',
    params: {
      page: 1,
      limit: 3,
      key: ''
    },
  },
  getters: {
    isArticel: state => {
      state.isArticel = JSON.parse(Storage.get('isArticel'))
      return state.isArticel
    },
    // 中部导航
    meanCenterObj: state => {
      state.meanCenterObj = JSON.parse(Storage.get('meanCenterObj')) || {
        title: "首页",
        name: 'Index',
        id: 0,
        _child: []
      }
      return state.meanCenterObj
    },
    system: state => {
      state.system = JSON.parse(Storage.get('system'))
      return state.system
    },
    // 头部导航
    meanTree: state => {
      state.meanTree = JSON.parse(Storage.get('meanTree'))
      // console.log(state.meanTree, 888)
      return state.meanTree
    },
    menus: state => {
      state.menus = JSON.parse(Storage.get('menus'))
      return state.menus

    },
    company: state => {
      state.company = JSON.parse(Storage.get('company'))
      return state.company

    },
    pageCate: state => {
      state.pageCate = JSON.parse(Storage.get('pageCate'))
      return state.pageCate

    },
  },
  actions: {
    async getCommon({ commit }) {
      try {
        const common = await api.COMMON()
        // console.log(common,'action')
        //测试环境
        common.system.logo = public_data.baseURL + common.system.logo
        common.meanTree = {
          name: 'Index',//组件名称
          tabName: 'Index',//选中子组件名称
          _child: common.menus
        }
        for (let key in common) {
          commit('setState', { prop: key, value: common[key] })
        }
        return Promise.resolve(common)
      } catch (err) {
        return Promise.reject(err)
      }
    },
    async getCate({ commit, getters, state }, e) {
      try {
        commit("setState", { prop: "loadOver", value: false });
        let id = e._child ? e._child.id : e.parent.id;
        const res = await api.CATE(id, e.params)
        let p1 = public_data.imageURL(res.cate.image);//cate栏目顶部图片
        let p2 = public_data.imageURL(res.list);//文章模块内的所有图片
        // console.log(res)
        // 有视频
        if (Object.keys(res.info).indexOf('attachment') > -1) {
          res.info.attachment = public_data.baseURL + res.info.attachment
        }
        // Promise.all([p1, p2])
        // .then((a) => {
        // res.cate.image = a[0];
        // Object.assign(e.parent, {
        //   image: a[0],
        // });
        // res.cate.image = a[0];
        Object.assign(e.parent, {
          image:res.cate.image,
        });
        // console.log(getters, 'geters')
        commit("setState", { prop: "pageCate", value: res });
        commit("setState", { prop: "hrefName", value: '' });
        commit('setState', {
          prop: "isArticel",
          value: {
            ...getters.isArticel,
            params: getters.pageCate.cate.id == getters.meanCenterObj.tabId ? getters.isArticel.params : {},
            status: false,
          },
        })
        if (e.parent.name !== getters.meanCenterObj.name || (window.location.href).indexOf('articelG') > -1) {
          router.push({ name: e.parent.name });
        }
        commit("setMenu", e);
        commit("setState", { prop: "loadOver", value: true });
        // console.log(e, getters, state)

        return Promise.resolve(res)
      } catch (err) {
        return Promise.reject(err)
      }
      // })
      // .catch((err) => {
      // return Promise.reject(err)
      // });
    },
    async toArticel({ commit, state }, e) {
      try {
        // console.log(e, '888')
        // 全局搜索
        let type = typeof (e.id) == 'string'
        var article
        // 栏目入口
        if (!e.id) {
          article = await api.CATE(e.cate.id)
        } else {
          // 文章详情
          article = await api.INFO(e)
        }
        // status=res.content==undefined&&type?false:true
        commit('setState', {
          prop: "isArticel",
          value: {
            status: type && article.content == undefined ? false : true,
            params: e,
            ...article,
            type: e.id ? 'info' : 'cate'
          },
        })
        return Promise.resolve(article)
        // }
      } catch (err) {
        return Promise.reject(err)
      }
    },
  },
  mutations: {
    // 修改state中的数据
    setState(state, e) {
      if (typeof (e.value) == 'object') {
        e.value = JSON.stringify(e.value)
      }
      state[e.prop] = e.value
      // 测试阶段缓存
      Storage.set({ prop: e.prop, value: e.value })
    },
    // 顶部导航
    setMenu(state, e) {
      let meanCenterObj = {}
      Object.assign(meanCenterObj, e.parent)
      if (e._child) {
        Object.assign(meanCenterObj, { tabName: e._child.name, tabTitle: e._child.title, tabId: e._child.id })
      }
      // 存入缓存,
      state.meanCenterObj = meanCenterObj
      Storage.set({ prop: 'meanCenterObj', value: JSON.stringify(meanCenterObj) })
    },
  }
})
export default store
let Storage = {
  get(name) {
    return localStorage.getItem(name)
  },
  set(e) {
    localStorage.setItem(e.prop, e.value)
  },
  remove(name) {
    localStorage.removeItem(name)
  }
}


// WEBPACK FOOTER //
// ./src/store/index.js